export type TransactionType = 'expense' | 'income';

export type TransactionCategory =
  | 'food'
  | 'transport'
  | 'shopping'
  | 'entertainment'
  | 'health'
  | 'education'
  | 'utilities'
  | 'housing'
  | 'travel'
  | 'other'
  | 'salary'
  | 'investment'
  | 'freelance'
  | 'gift';

export interface Transaction {
  id: string;
  userId: string;
  type: TransactionType;
  category: TransactionCategory;
  amount: number;
  currency: string;
  description: string;
  merchant?: string;
  date: string;
  createdAt: string;
  updatedAt: string;
  receiptId?: string;
  tags?: string[];
  notes?: string;
  location?: TransactionLocation;
}

export interface TransactionLocation {
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  coordinates?: {
    lat: number;
    lng: number;
  };
}

export interface TransactionFilters {
  type?: TransactionType;
  category?: TransactionCategory;
  startDate?: string;
  endDate?: string;
  minAmount?: number;
  maxAmount?: number;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: 'date' | 'amount' | 'category';
  sortOrder?: 'asc' | 'desc';
}

export interface TransactionListResponse {
  transactions: Transaction[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface TransactionSummary {
  totalIncome: number;
  totalExpense: number;
  balance: number;
  transactionCount: number;
  averageExpense: number;
  topCategories: CategorySummary[];
}

export interface CategorySummary {
  category: TransactionCategory;
  amount: number;
  count: number;
  percentage: number;
}

export interface TrendData {
  date: string;
  income: number;
  expense: number;
  balance: number;
}

export const CATEGORY_LABELS: Record<TransactionCategory, string> = {
  food: 'Alimentacao',
  transport: 'Transporte',
  shopping: 'Compras',
  entertainment: 'Entretenimento',
  health: 'Saude',
  education: 'Educacao',
  utilities: 'Contas',
  housing: 'Moradia',
  travel: 'Viagem',
  other: 'Outros',
  salary: 'Salario',
  investment: 'Investimento',
  freelance: 'Freelance',
  gift: 'Presente',
};

export const CATEGORY_COLORS: Record<TransactionCategory, string> = {
  food: '#ef4444',
  transport: '#f97316',
  shopping: '#eab308',
  entertainment: '#84cc16',
  health: '#22c55e',
  education: '#14b8a6',
  utilities: '#06b6d4',
  housing: '#3b82f6',
  travel: '#6366f1',
  other: '#8b5cf6',
  salary: '#22c55e',
  investment: '#14b8a6',
  freelance: '#3b82f6',
  gift: '#ec4899',
};
